import { render, staticRenderFns } from "./NewGeneralMedecine.vue?vue&type=template&id=c8bec5d2"
import script from "./NewGeneralMedecine.vue?vue&type=script&lang=js"
export * from "./NewGeneralMedecine.vue?vue&type=script&lang=js"
import style0 from "./NewGeneralMedecine.vue?vue&type=style&index=0&id=c8bec5d2&prod&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports